import { RequestData } from '@ant-design/pro-table';
import { normalizeEmail } from '@/utils/email';
import { request } from '@/utils/request';

export enum CASH_METHOD {
  CASH_PICKUP = 'CASH_PICKUP',
  CASH_DROP_OFF = 'CASH_DROP_OFF'
}

export enum CashInOutStatusGroup {
  NEW = 'NEW',
  PENDING_APPROVAL = 'PENDING_APPROVAL',
  PENDING_PAYMENT = 'PENDING_PAYMENT',
  'PENDING PAYMENT' = 'PENDING PAYMENT',
  REQUESTED = 'REQUESTED',
  PROCESSING = 'PROCESSING',
  COMPLETED = 'COMPLETED',
  DRAFT = 'DRAFT',
  CANCELLED = 'CANCELLED',
  SUCCESS = 'SUCCESS',
  APPROVE = 'APPROVE',
  CANCEL = 'CANCEL'
}

export interface CashInOutListItem {
  user: {
    id: string;
    name: string;
    email: string;
    accountId: string;
  };
  id: string;
  amount: string;
  currency: string;
  date: string;
  method: CASH_METHOD;
  refId: string;
  type: string;
  latestRemarks: string;
  tags: Array<{
    id: string;
    tag: string;
    tagColor: string;
  }>;
  relationshipManager: {
    id: string;
    name: string;
  };
  appointmentTime: {
    appointmentDateTimeTo: string;
    appointmentDateTimeFrom: string;
  };
  status: string;
}

export async function queryCashInOut(params: any): Promise<RequestData<CashInOutListItem>> {
  if (params.date) {
    params.from = params.date[0];
    params.to = params.date[1];
    delete params.date;
  }

  if (params.appointmentTime) {
    params.appointmentTimeFrom = params.appointmentTime[0];
    params.appointmentTimeTo = params.appointmentTime[1];
    delete params.appointmentTime;
  }
  if (params['user,email']) {
    params.email = normalizeEmail(params['user,email']);
    delete params['user,email'];
  }

  const data = await request<RequestData<CashInOutListItem>>('/instructions/cash-in-out', {
    params
  });
  return data;
}

/**
 * Get pending cash in/out count
 * Filters by status: NEW, PENDING_APPROVAL, PENDING_PAYMENT, REQUESTED, PROCESSING
 */
export async function queryCashInOutPendingCount(): Promise<number> {
  const response = await request<RequestData<CashInOutListItem>>('/instructions/cash-in-out', {
    params: {
      current: 1,
      pageSize: 1,
      status: ['NEW', 'PENDING_APPROVAL', 'PENDING_PAYMENT', 'REQUESTED', 'PROCESSING']
    }
  });
  return response.total ?? 0;
}
